import { render } from "./OrderDetailView.vue?vue&type=template&id=589e92ee&scoped=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=js"
export * from "./OrderDetailView.vue?vue&type=script&lang=js"

import "./OrderDetailView.vue?vue&type=style&index=0&id=589e92ee&scoped=true&lang=css"
import "./OrderDetailView.vue?vue&type=style&index=1&id=589e92ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589e92ee"]])

export default __exports__